import { MakeBackendRequest } from "./MakeBackendRequest";

export const fetchNotifications = async (userId) => {
  try {
    const response = await MakeBackendRequest({
      urlSuffix: `/api/v1/users/${userId}/notifications`,
      method: "get",
      data: {},
    });

    return response.data;
  } catch (error) {
    throw error.response;
  }
};
